import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "tagsContainer", "link"];
  static values = { programId: String };

  async loadAll(event) {
    event.preventDefault();
    const promoUrl = this.linkTarget.href;
    const tagsUrl = `/tag_candidates?program_id=${this.programIdValue}&format=json`;

    try {
      // 1. Fire both requests. promoRes is the first result, tagsRes is the second.
      const [promoRes, tagsRes] = await Promise.all([
        fetch(promoUrl, { headers: { "Accept": "application/json" } }),
        fetch(tagsUrl, { headers: { "Accept": "application/json" } })
      ]);

      // 2. Handle 500 Errors
      if (!promoRes.ok && promoRes.status === 500) {
        this.containerTarget.innerHTML = "<div class='error'>Server error loading promo.</div>";
        return;
      }

      // 3. Handle HTML Redirect (Full-screen view)
      const promoType = promoRes.headers.get("content-type");
      if (promoType && promoType.includes("text/html")) {
        window.location.href = promoRes.url;
        return;
      }

      // 4. Handle Promo JSON (The Form)
      if (promoRes.ok && promoRes.status !== 204) {
        const promoData = await promoRes.json();
        this.containerTarget.innerHTML = promoData.html || "";
      }

      // 5. Handle Tag Candidates JSON
      if (tagsRes.ok && tagsRes.status !== 204) {
        const tagsData = await tagsRes.json();
        this.tagsContainerTarget.innerHTML = tagsData.html || tagsData.message || "";
      } else if (tagsRes.status === 204) {
        this.tagsContainerTarget.innerHTML = "";
      }

    } catch (error) {
      console.error("Stimulus Error:", error);
    }
  }
}
